module.exports = __webpack_public_path__ + "static/media/portrait_nightwatch.d833ab9c.jpeg";